import React from 'react';
import { footerCols, brands } from '../data';

const brandUrlByName = brands.reduce((acc, b) => {
  if (b.website) acc[b.name] = b.website;
  return acc;
}, {});

export default function Footer() {
  return (
    <footer className="footer" id="contact">
      <div className="container footer__grid">
        <div className="footer__brand">
          <img
            className="footer__logo"
            src={`${process.env.PUBLIC_URL}/images/Logo-caladium.png`}
            alt="Caladium Systems"
          />
          <p className="footer__about">
            Building intelligent ecosystems that connect people, experiences
            and opportunities to celebrate life.
          </p>
        </div>

        {footerCols.map((col) => (
          <div className="footer__col" key={col.title}>
            <h4>{col.title}</h4>
            <ul>
              {col.links.map((link) => {
                const url = col.title === 'BRANDS' ? brandUrlByName[link] : null;
                return (
                  <li key={link}>
                    <a
                      href={url || '#contact'}
                      target={url ? '_blank' : undefined}
                      rel={url ? 'noopener noreferrer' : undefined}
                    >
                      {link}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>

      <div className="container footer__bottom">
        <span>&copy; {new Date().getFullYear()} Caladium Systems. All rights reserved.</span>
      </div>
    </footer>
  );
}
